export enum uiActionTypes {
  USER_NEEDS_REGISTRATION = 'user_needs_registration',
  USER_NEEDS_CFE_CREDENTIALS = 'user_needs_cfe_credentials',
  DONT_REMIND_USER_CFE_CFEDENTIALS = 'dont_remind_user_cfe_credentials',
}
